<h2 class="text-center text-strong p-3">Thank you. We automatically redirect back to you.</h2>
<h2 class="text-center text-strong p-3">If you not redirected, click to Continue button, please.</h2>
<div class="text-center">
  <button mat-flat-button color="primary">
    <span (click)="redirect()">Continue</span>
  </button>
</div>
